// @flow
import * as React from 'react';
import {  Portal, useAgentByIdQuery } from '../../../../../shared';
import moment from 'moment/moment';
import { getUserName } from '@coverright/utils';
import { formatToPhoneNumber } from '@coverright/ui/inputs';
import { StyledRecord } from './styled-record';
import { Divider, Typography } from '@mui/material';
import { withButton } from '../../../../../features';
import { getEnrollmentTypeSubtitle, getEnrollmentTypeTitle } from '../lib';
import { MaEnrollmentEditButton } from './ma-enrollment-form';
import { EnrollmentListItemOutput, MedicareEnrollmentType } from '@coverright/data-access/types/enrollment';

type Props = {
  enrollment: EnrollmentListItemOutput;
  onChange: () => void,
};
export const Card = ({enrollment}: Props) => {
  const {data} = useAgentByIdQuery({
    variables: {
      id: enrollment.agentId
    },
    skip: !enrollment.agentId
  })

  const agent = data?.agentById ? getUserName(data?.agentById) : '';

  const location = `${enrollment.zip} ${enrollment.county}`

  return (
    <Portal sx={{p: 1, alignSelf: 'stretch', mb: 2}}>
      <Typography align={'center'} variant={'body2'} sx={{lineHeight: 1, bgcolor: '#FCF2C9', mx: -1, mt: -1, mb: 1, p: 1, fontWeight: 500}}>
        Medicare Advantage
      </Typography>
      <StyledRecord title={'Name'} value={getUserName(enrollment)} />
      <StyledRecord title={'Email'} tooltip={enrollment.email} value={enrollment.email} />
      <StyledRecord title={'Phone'} value={formatToPhoneNumber(enrollment.phoneNumber)} />
      <StyledRecord title={'Birth date'} value={`${moment.utc(enrollment.birthDate).format('MM/DD/YYYY')}`} />
      <StyledRecord title={'Location'} value={location} />
      <Divider sx={{my: 1, mx: -1}} />
      {enrollment.bidId && <StyledRecord title={'Plan'} value={enrollment.bidId} />}
      {enrollment.started && <StyledRecord title={'Started'} value={`${moment.utc(enrollment.started).format('MM/DD/YYYY')}`} />}
      {enrollment.approvedAt && <StyledRecord title={'Approved'} value={`${moment.utc(enrollment.approvedAt).format('MM/DD/YYYY')}`} />}
      {enrollment.carrierName && <StyledRecord title={'Carrier'} tooltip={enrollment.carrierName} value={enrollment.carrierName} />}
      {enrollment.agentId && <StyledRecord title={'Writing agent'} value={agent} />}
      {false && enrollment.status && <StyledRecord title={'Status'} sx={{'& .record-value': {color: 'warning.500'}}} value={enrollment.status} />}
      {enrollment.planName && <StyledRecord title={'Plan name'} tooltip={enrollment.planName} value={enrollment.planName} />}
      {enrollment.enrollmentType && <StyledRecord title={'Type'}
                                                  tooltip={getEnrollmentTypeSubtitle(enrollment.enrollmentType as MedicareEnrollmentType)}
                                                  value={getEnrollmentTypeTitle(enrollment.enrollmentType as MedicareEnrollmentType)} />}
    </Portal>
  );
};

export const MaEnrollment = withButton(
  Card,
  MaEnrollmentEditButton
)
